export const userConfig = {
  USER_TOKEN: "USER_TOKEN",
  RESET: "RESET",
};

export const modalConfig = {
  OPEN_REFRESH_MODAL: "OPEN_REFRESH_MODAL",
  CLOSE_REFRESH_MODAL: "CLOSE_REFRESH_MODAL",
};

// export const socketConfig = {
//   SET_SOCKET: "SET_SOCKET",
//   GET_SOCKET: "GET_SOCKET",
//   GET_MESSAGES: "GET_MESSAGES",
//   GET_STATE: "GET_STATE",
// };
